import { Button, Modal } from "react-bootstrap";
import axios from "axios";
import actions from "../../redux/actions/adminsActions";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";

function CreateAdmin({ showCreate, setShowCreate, token }) {
  const dispatch = useDispatch();
  const handleCloseCreate = () => setShowCreate(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onSubmit = async (data) => {
    const response = await axios({
      method: "POST",
      url: process.env.REACT_APP_API_URL + "/api/admins",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    });
    dispatch(actions.createAdmin(response));
    setShowCreate(false);
  };

  return (
    <Modal className="modals" show={showCreate} onHide={handleCloseCreate}>
      <Modal.Header closeButton>
        <Modal.Title>Add a new admin</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)} className="mt-3">
          <div className="row mb-3">
            <div className="col">
              <div className="form-outline">
                <label
                  className="visually-hidden form-label"
                  htmlFor="form6Example1"
                >
                  First name
                </label>
                <input
                  placeholder="First Name"
                  type="text"
                  className="form-control"
                  {...register("firstname", { required: true })}
                />
                {errors.firstname && (
                  <span className="text-danger f-roboto">
                    This field is required
                  </span>
                )}
              </div>
            </div>
            <div className="col">
              <div className="form-outline">
                <label
                  className="visually-hidden form-label"
                  htmlFor="form6Example2"
                >
                  Last name
                </label>
                <input
                  placeholder="Last Name"
                  type="text"
                  id="lastname"
                  className="form-control"
                  {...register("lastname", { required: true })}
                />
                {errors.lastname && (
                  <span className="text-danger f-roboto">
                    This field is required
                  </span>
                )}
              </div>
            </div>
          </div>

          <div className="form-outline mb-3">
            <label
              className="visually-hidden form-label"
              htmlFor="form6Example5"
            >
              Email
            </label>
            <input
              placeholder="E-mail"
              type="email"
              id="email"
              className="form-control"
              name="email"
              {...register("email", { required: true })}
            />
            {errors.email && (
              <span className="text-danger f-roboto">
                This field is required
              </span>
            )}
          </div>

          <div className="form-outline mb-3">
            <label
              className="visually-hidden form-label"
              htmlFor="form6Example5"
            >
              Password
            </label>
            <input
              placeholder="Password"
              type="password"
              id="password"
              className="form-control"
              {...register("password", { required: true })}
            />
            {errors.password && (
              <span className="text-danger f-roboto">
                This field is required
              </span>
            )}
          </div>

          <div className="form-check mt-4 ms-1 mb-3">
            <input
              className="form-check-input me-2"
              type="checkbox"
              value=""
              id="form6Example8"
            />
            <label className="form-check-label" htmlFor="form6Example8">
              {" "}
              Send notification via E-mail{" "}
            </label>
          </div>
          <div className="d-flex justify-content-end mt-4">
            <button type="submit" className="btn btn-success btn-block me-2">
              Add admin
            </button>
            <Button variant="outline-secondary" onClick={handleCloseCreate}>
              Close
            </Button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}

export default CreateAdmin;
